import { Skeleton, type SkeletonProps } from "@mantine/core";
import type { JSX, PropsWithChildren } from "react";

export const SkeletonPlaceholder = ({ children, visible, ...rest }: PropsWithChildren<SkeletonProps>): JSX.Element => {
    return visible ? <Skeleton height={"var(--mantine-font-size-md)"} {...rest} /> : <>{children}</>;
};
